import { useEffect, useRef, useState } from "react";
import { useAuth } from "../AuthContext";
import { apiFetch } from "../../../utils/api";

/** Same polling pattern as useArticleBrief but points at /api/knowledge/{id}/brief */
export const useKnowledgeBrief = (id, auto) => {
  const { user, loading } = useAuth();
  const userId = user?.user_id, tier = user?.subscription_tier;
  const [data, setData]   = useState(null);
  const [error, setError] = useState("");
  const [locked, setLocked] = useState(false);
  const [action, setAction] = useState(0);
  const started = useRef(new Set());

  useEffect(() => {
    let active = true, timer;
    setData(null); setError(""); setLocked(false);
    if (loading) return;
    if (!userId) { setLocked(true); return; }
    const endpoint = `/api/knowledge/${id}/brief`;
    const failure = err => {
      if (!active) return;
      if ([401, 402, 403].includes(err.status)) setLocked(true);
      else {
        setError("This knowledge brief could not be loaded. Please retry.");
        setData(v => v?.status === "pending" ? { ...v, status: "failed" } : v);
      }
    };
    const accept = result => {
      if (!active) return;
      setData(result.data);
      if (result.data.status === "pending")
        timer = setTimeout(() => apiFetch(endpoint).then(accept).catch(failure), 1800);
    };
    const key = `${id}:${userId}:${action}`;
    apiFetch(endpoint).then(result => {
      if (!active) return;
      accept(result);
      if ((auto || action > 0) && ["not_prepared", "failed"].includes(result.data.status) && !started.current.has(key)) {
        if (result.data.status === "failed" && action === 0) return;
        started.current.add(key);
        setData(v => ({ ...v, status: "pending" }));
        apiFetch(endpoint, { method: "POST" }).then(accept).catch(failure);
      }
    }).catch(failure);
    return () => { active = false; clearTimeout(timer); };
  }, [id, auto, action, loading, userId, tier]);

  return {
    data, error, locked,
    busy: data?.status === "pending",
    prepare: () => setAction(v => v + 1),
    selectEdition: () => {},
  };
};
